import Vue from 'vue';
import ProxyUrl from '@/constants/ProxyUrls';
import PageSetup from '@/dto/PageDTO.json';
import _ from 'lodash';
import Pagination from '@/dto/Pagination.json';

export default {
  namespaced: true,
  state: {
    orders: [],
    orderStatus: '',
    pagination: {},
    openOrder: null,
    pagination: _.cloneDeep(Pagination),
    sortBy: {"auditLog.createdOn":-1},
  },

  mutations: {

    setOpenOrder(state, order) {
      state.openOrder = order;
    },

    setOrderStatus(state, val) {
      state.orderStatus = val;
    },

    setComments(state, payload) {
      if (state.openOrder) {
        state.openOrder.comments = payload;
      }
    },

    setOrders(state, payload) {
      state.orders = [];
      state.orders.push(...payload.docs);
    },

    setPagination(state, payload) {
      if (payload) {
        state.pagination.page = payload.page;
        state.pagination.total = payload.total;
        state.pagination.limit = payload.limit;
      }
    },
  },

  actions: {
    async commentRequest({
      commit,
    }, reqData) {
      try {
        reqData.url = ProxyUrl[`${reqData.method}Comment`];
        const {
          data,
        } = await Vue.prototype.$axios(reqData);

        if (!data) throw new Error("Data doesn't exist");

        if (data.httpStatus === 200) {
          commit('setComments', data.responseData);
          return true;
        }
        return false;
      } catch (error) {
        throw new Error(error);
      }
    },
    async cancelOrder({
      commit,
    }, orderId) {
      try {
        const {
          data,
        } = await Vue.prototype.$axios({
          url: ProxyUrl.cancelOrder,
          method: 'POST',
          data: {
            orderId,
          },
        });

        if (!data) {
          throw new Error('No Data');
        }
        if (data.httpStatus === 200) {
          commit('setOpenOrder', null);
          return true;
        }

        console.log('HTTP', data.httpStatus === 200);
        return false;
      } catch (error) {
        throw new Error(error);
      }
    },
    async markAsDelivered({
      commit,
    }, {
      deliveryDetail,
      editMode,
    }) {
      try {
        const {
          data,
        } = await Vue.prototype.$axios({
          method: editMode ? 'PUT' : 'POST',
          url: editMode ? ProxyUrl.editDelivered : ProxyUrl.markDelivered,
          data: deliveryDetail,
        });

        if (data.httpStatus === 200) {
          commit('setOpenOrder', data.responseData);
          return true;
        }

        return false;
      } catch (error) {
        throw new Error(error);
      }
    },
    async markAsShipped({
      commit,
    }, {
      shippingDetails,
      editMode,
    }) {
      try {
        const {
          data,
        } = await Vue.prototype.$axios({
          method: editMode ? 'PUT' : 'POST',
          url: editMode ? ProxyUrl.editShipped : ProxyUrl.markShipped,
          data: shippingDetails,
        });

        if (data.httpStatus === 200) {
          commit('setOpenOrder', data.responseData);
          return true;
        }

        return false;
      } catch (error) {
        throw new Error(error);
      }
    },
    async fulfillItem({
      commit,
    }, payload) {
      try {
        const {
          data,
        } = await Vue.prototype.$axios({
          method: payload.editMode ? 'PUT' : 'POST',
          url: payload.editMode ? ProxyUrl.editFulfillOrder : ProxyUrl.fulfillOrder,
          data: payload.fulfillmentDetail,
        });

        if (data.httpStatus === 200) {
          commit('setOpenOrder', data.responseData);
          return true;
        }

        return false;
      } catch (error) {
        throw new Error(error);
      }
    },
    async confirmOrder({
      commit,
      state,
    }) {
      if (!state.openOrder || state.openOrder == null) return false;
      const reqObj = {
        orderId: state.openOrder._id,
      };
      try {
        const {
          data,
        } = await Vue.prototype.$axios({
          method: 'post',
          url: ProxyUrl.confirmOrder,
          data: reqObj,
        });

        if (data.httpStatus === 200) {
          commit('setOpenOrder', data.responseData);
          return true;
        }

        return false;
      } catch (error) {
        throw new Error(error);
      }
    },
    async getOrdersByStatus({
      commit,
      state
    }, filters) {
      let reqObj = {
        orderStatus: status,
        pagingOptions: state.pagination,
        sortRule: state.sortBy
      };
      try {
        const {
          data,
        } = await Vue.prototype.$axios({
          url: ProxyUrl.getOrderByStatus,
          method: 'post',
          data: reqObj,
        });
        commit('setOrders', data.responseData);
        commit('setOrderStatus', status);
        commit('setPagination', data.responseData);
      } catch (error) {
        throw new Error(error);
      }
    },
    async openOrderDetail({
      commit,
    }, order) {
      if (!order || !order._id) return false;
      const orderID = order._id;

      try {
        const {
          data,
        } = await Vue.prototype.$axios({
          url: ProxyUrl.getSingleOrderById + orderID,
          method: 'get',
        });

        if (data.httpStatus === 200) {
          commit('setOpenOrder', data.responseData);
          return true;
        }

        return false;
      } catch (error) {
        throw new Error(error);
      }
    },
  },

  getters: {
    orderStatus(state) {
      return state.orderStatus;
    },
    orders(state) {
      return state.orders;
    },
    openOrder(state) {
      return state.openOrder;
    },
    pagination(state) {
      return state.pagination;
    },
  },
};
